import { useEffect, useState } from "react";

import {
  getComments,
  createComment,
} from "../api/comments";

import {
  getSelectedClinicId,
} from "../store/selectedClinicStore";

export default function PassportComments() {

  const [comment, setComment] = useState("");

  const [comments, setComments] = useState([]);

  const [loading, setLoading] = useState(true);

  const clinicId = getSelectedClinicId();

  useEffect(() => {
    loadComments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadComments = async () => {

    try {

      const response = await getComments({
        clinic_id: clinicId,
        type: "passport",
      });

      setComments(response.data);

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }
  };

  const saveComment = async () => {

    if (!comment.trim()) {
      return;
    }

    try {

      await createComment({
        clinic: clinicId,
        comment_type: "passport",
        text: comment,
      });

      setComment("");

      loadComments();

    } catch (error) {

      console.error(error);

    }
  };

  return (
    <div
      style={{
        marginTop: "20px",
        border: "1px solid #ddd",
        padding: "15px",
        borderRadius: "8px",
      }}
    >

      <h3>Комментарии инспектора</h3>

      {/* список комментариев */}

      {loading ? (

        <div>Загрузка...</div>

      ) : (

        <div style={{ marginBottom: "15px" }}>

          {comments.map((item) => (

            <div
              key={item.id}
              style={{
                borderBottom: "1px solid #eee",
                padding: "10px 0",
              }}
            >

              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: "4px",
                }}
              >
                {item.author_name}
              </div>

              <div>
                {item.text}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  marginTop: "4px",
                }}
              >
                {new Date(item.created_at).toLocaleString()}
              </div>

            </div>

          ))}

        </div>

      )}

      {/* добавление комментария */}

      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={4}
        style={{
          width: "100%",
          padding: "10px",
        }}
      />

      <button
        style={{ marginTop: "10px" }}
        onClick={saveComment}
      >
        Сохранить комментарий
      </button>

    </div>
  );
}
